interface CarouselBreakpoint {
    perView?: number | 'auto'
    spacing?: number
    drag?: boolean
    origin?: 'auto' | 'center' | number
    slides?: CarouselSlidesObject | number
}

interface CarouselSlidesObject {
    origin?: 'auto' | 'center' | number
    spacing?: number
    perView?: number | 'auto'
    number?: number
}

export interface CarouselBreakpoints {
    desktop: CarouselBreakpoint
    mobile: CarouselBreakpoint
}

export interface OptionsBreakpoints {
    [key: string]: CarouselBreakpoint
}

export interface CarouselOptions {
    mode?: 'snap' | 'free' | 'free-snap'
    spacing?: number
    perView: number | 'auto'
    breakPoints?: CarouselBreakpoints
    loop?: boolean
    slides?: CarouselSlidesObject | number
    breakpoints?: OptionsBreakpoints
    rtl?: boolean
}

export enum CarouselArrowType {
    PDP = 'pdp',
    ProductList = 'product-list',
    PinkBox = 'pink-box',
    MediumCarousel = 'medium-carousel',
}

export interface ArrowProps {
    disabled?: boolean
    direction?: 'right' | 'left'
    onClick: (e: React.MouseEvent) => void
    type: CarouselArrowType
}

export enum DotsType {
    HomePage = 'home-page',
    PDP = 'PDP',
    CLOSEUP = 'CLOSEUP',
}
